// extracted by mini-css-extract-plugin
module.exports = {"slider":"Qnic8FUzgepY0Wg7OGGa"};